import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import {
  Wrapper,
  ContentContainer,
  TitleText,
  DescriptionText,
  ProgramDetailImage,
  ProgramDetailStepsContainer,
  ProgramDetailStepsWrapper,
  ProgramDetailStepContent,
  ProgramDetailStepWrapper,
  ProgramDetailStepIcon,
  ProgramDetailStepIconWrapper,
  ProgramDetailStepItem,
  ProgramDetailStepItemTitleText,
  ProgramDetailStepItemTitleCaption,
  ProgramDetailStepItemImageContainer,
  ProgramDetailStepItemImage,
  ProgramDetailStepItemImageTitle,
  ProgramDetailStepItemContainer,
  ProgramDetailStepItemContainer2,
  ProgramDetailStepItemLinkText,
} from './SalonProgramDetailPage.style';
import Image from '../../../components/ContentfulImage';
import Modal from '../../../components/Modal/RecieverFragments';
import { TABLET_P } from '../../../constants';
import Placeholder from '../../../components/Placeholder';
import { generateKey } from '../../../utils';

class SalonProgramDetailPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenModal: false,
      currentProduct: null,
      src: null,
    };

    // 商品の使用説明モーダルに画像を表示させる際に呼ばれる
    this.getProductImageInfo = this.getProductImageInfo.bind(this);

    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  /**
   * 商品の使用説明モーダルに画像を表示させる際に呼ばれる
   *   目的: 画像情報を引き渡すため
   */
  getProductImageInfo = (variants = []) => {
    for (let i = 0; i < variants.length; i += 1) {
      if (variants[i] && variants[i].salonExclusive === true) {
        return variants[i].image;
      }
    }
    return variants[0].image;
  };

  showModal = selectedProduct => {
    this.setState({
      isOpenModal: true,
      currentProduct: selectedProduct,
      src: this.getProductImageInfo(_.get(selectedProduct, 'product.variants')),
    });
  };

  hideModal = () => {
    this.setState({ isOpenModal: false, currentProduct: null });
  };

  render() {
    const { copy, locale, salonSolutionData, match } = this.props;
    const { slug } = match.params;
    const programDetail =
      salonSolutionData &&
      ((salonSolutionData.hairCare && salonSolutionData.hairCare.find(e => e.slug === slug)) ||
        (salonSolutionData.scalpCare && salonSolutionData.scalpCare.find(e => e.slug === slug)) ||
        (salonSolutionData.hairAndScalpCare && salonSolutionData.hairAndScalpCare.find(e => e.slug === slug)));
    const { title, description, image, steps } = (programDetail && programDetail.steps && programDetail.steps) || [];

    let stepCount = 0;
    const DetailImageRatio = 13 / 40;

    const getProductImageInfo = (variants = []) => {
      for (let i = 0; i < variants.length; i += 1) {
        if (variants[i] && variants[i].salonExclusive === true) {
          return variants[i].image;
        }
      }
      return variants[0].image;
    };

    const getModalCopy = cp => {
      if (!cp) return {};
      return {
        usage: cp && cp.common && cp.common.usage ? cp.common.usage : null,
        method: cp && cp.common && cp.common.method ? cp.common.method : null,
      };
    };

    const renderStepCount = count => {
      if (stepCount !== count) {
        stepCount = count;
        return <ProgramDetailStepIcon>{stepCount}</ProgramDetailStepIcon>;
      }
      return null;
    };

    const getItemContainerWidth = item => {
      if (item && item.products) {
        if (item.products.length >= 4) {
          return 400;
        }
        return 100 * item.products.length;
      }
      return 0;
    };

    return (
      <React.Fragment>
        <Wrapper>
          <ContentContainer>
            <TitleText>
              {title || <Placeholder w="100%" h={window.innerWidth > TABLET_P ? '45px' : '30px'} />}
            </TitleText>
            <DescriptionText>
              {description || <Placeholder w="100%" h={window.innerWidth > TABLET_P ? '54px' : '63px'} />}
            </DescriptionText>
            <ProgramDetailImage height={`${window.innerWidth * DetailImageRatio}px`}>
              {!image ? (
                <Placeholder w="100%" h="100%" />
              ) : (
                <Image
                  src={image}
                  options={{
                    w: '100%',
                    h: window.innerWidth > TABLET_P ? '100%' : `${window.innerWidth * DetailImageRatio}px`,
                    objectFit: 'cover',
                  }}
                />
              )}
            </ProgramDetailImage>
            <ProgramDetailStepsContainer>
              {!steps ? (
                <Placeholder w="100%" h="300px" />
              ) : (
                <ProgramDetailStepsWrapper>
                  <ul className="programbar">
                    <ProgramDetailStepsWrapper>
                      {steps.map((programStep, programStepIndex) => (
                        <li key={generateKey('programDetailStep', programStepIndex)}>
                          <ProgramDetailStepContent>
                            {programStep.items.map((item, itemIndex) => (
                              <ProgramDetailStepWrapper key={generateKey('programDetailStepWrapper', itemIndex)}>
                                <ProgramDetailStepIconWrapper>
                                  {renderStepCount(programStepIndex + 1)}
                                </ProgramDetailStepIconWrapper>
                                <ProgramDetailStepItem key={generateKey('programDetailStepItem', itemIndex)}>
                                  <ProgramDetailStepItemContainer>
                                    <ProgramDetailStepItemTitleText>{item.title}</ProgramDetailStepItemTitleText>
                                    {!!item.remarks && (
                                      <ProgramDetailStepItemTitleCaption>
                                        {item.remarks}
                                      </ProgramDetailStepItemTitleCaption>
                                    )}
                                    {!!item.link &&
                                      !!item.link.url && (
                                        <ProgramDetailStepItemLinkText>
                                          <Link
                                            to={`/${locale}${item.link.url}`}
                                            href={`/${locale}${item.link.url}`}
                                            target={item.link.external ? '_blank' : '_self'}
                                          >
                                            {item.link.label}
                                          </Link>
                                        </ProgramDetailStepItemLinkText>
                                      )}
                                  </ProgramDetailStepItemContainer>
                                  <ProgramDetailStepItemContainer2
                                    style={{
                                      width: window.innerWidth > TABLET_P ? getItemContainerWidth(item) : '100%',
                                    }}
                                  >
                                    {!!item &&
                                      !!item.products &&
                                      item.products.map((product, index) => (
                                        <ProgramDetailStepItemImageContainer
                                          key={generateKey('programDetailStepItemImage', index)}
                                          onClick={() => {
                                            this.showModal({ ...product, usage: product.usage });
                                          }}
                                        >
                                          <ProgramDetailStepItemImage>
                                            {!!product.product &&
                                              !!product.product.variants && (
                                                <Image
                                                  src={getProductImageInfo(product.product.variants)}
                                                  options={{ w: '100%', h: '100%', objectFit: 'contain' }}
                                                />
                                              )}
                                          </ProgramDetailStepItemImage>
                                          {!!product.product &&
                                            !!product.product.name && (
                                              <ProgramDetailStepItemImageTitle>
                                                {product.product.name}
                                              </ProgramDetailStepItemImageTitle>
                                            )}
                                        </ProgramDetailStepItemImageContainer>
                                      ))}
                                  </ProgramDetailStepItemContainer2>
                                </ProgramDetailStepItem>
                              </ProgramDetailStepWrapper>
                            ))}
                          </ProgramDetailStepContent>
                        </li>
                      ))}
                    </ProgramDetailStepsWrapper>
                  </ul>
                </ProgramDetailStepsWrapper>
              )}
            </ProgramDetailStepsContainer>
          </ContentContainer>
        </Wrapper>
        <Modal
          isOpen={this.state.isOpenModal}
          hasHeader
          onClose={this.hideModal}
          contentBodyItems={[
            {
              type: 'IMAGE_CONTENT',
              item: {
                product: this.state.currentProduct,
                copy: getModalCopy(copy),
                src: this.state.src,
              },
            },
          ]}
          styleType="salonSolutionType"
        />
      </React.Fragment>
    );
  }
}

SalonProgramDetailPage.defaultProps = {
  copy: {},
  salonSolutionData: {},
};
SalonProgramDetailPage.propTypes = {
  copy: PropTypes.shape({}),
  match: PropTypes.shape().isRequired,
  locale: PropTypes.string.isRequired,
  salonSolutionData: PropTypes.shape({}),
};
const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  salonSolutionData: state.salonSolutionList,
  locale: state.locale,
});

export default connect(mapState)(SalonProgramDetailPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SalonProgramDetailPage/SalonProgramDetailPage.js